import React from 'react';

import { Footer, Header, PageLayout } from '../../components';
import PageContent from '../../features/Invoices';
import { useAuthValidation } from '../../utils/hooks';

const InvoicesPage = () => {
  useAuthValidation();

  return (
    <>
      <Header />
      <PageLayout>
        <PageContent />
      </PageLayout>
      <Footer />
    </>
  );
};

export default InvoicesPage;
